import { MenuItem, Select, InputBase } from '@mui/material';
import React from 'react';

export function PaginationToolbar ({ sizePerPageList, sizePerPage, onSizePerPageChange }) {
    const sizeList = sizePerPageList || [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
    ];

    const onSizeChange = event => {
        const newSize = +event.target.value;
        onSizePerPageChange(newSize);
        localStorage.setItem('sizePerPage', newSize);
    };

    return (
        <div className='d-flex align-items-center'>
            <Select
                input={<InputBase className='inputBase' />}
                label={sizePerPage}
                value={sizePerPage}
                onChange={onSizeChange}
                className='pagination-select'
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null
                }}
            >
                {sizeList.map(option => {
                    const isSelect = sizePerPage === option.value;
                    return (
                        <MenuItem
                            key={option.text}
                            value={option.value}
                            className={`custom-options${isSelect ? '-selected' : ''}`}
                        >
                            {option.text}
                        </MenuItem>
                    );
                })}
            </Select>
        </div>
    );
}
